import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Form, Grid } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { OHIO_DAILY_WORKSHEET_REPORT_FORM_NAME } from 'Common/FormEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { TitledCard } from 'Components/';
import { OhioDailyWorksheetReportFieldEnum as Fields } from 'Common/FieldEnum';
import { mealTypeOptions } from '../helpers/constants';
import {
  DatePickerField,
  SelectField,
  InputField,
} from 'Common/SemanticWrapper';
import { MONTH_YEAR_DATE_FORMAT } from 'Common/Constants';
import SelectSitesTable from 'Common/SelectSitesTableReduxForm';

class OhioDailyWorksheetFormContainer extends Component {
  static propTypes = {
    nonNeedyItemOptions: PropTypes.array,
  };

  static defaultProps = {
    nonNeedyItemSelect: false,
  };

  render() {
    const { nonNeedyItemOptions } = this.props;
    return (
      <Fragment>
        <Form name={OHIO_DAILY_WORKSHEET_REPORT_FORM_NAME}>
          <TitledCard title={''}>
            <Grid>
              <Grid.Row>
                <Grid.Column className="input-group--btn-group">
                  <ReduxFormButtonGroup
                    label={'Meal Type'}
                    formName={OHIO_DAILY_WORKSHEET_REPORT_FORM_NAME}
                    options={mealTypeOptions}
                    fieldName={Fields.MealType}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={6}>
                  <Field
                    label={'County'}
                    name={Fields.County}
                    component={InputField}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column>
                  <Field
                    name={Fields.Date}
                    component={DatePickerField}
                    dateFormat={MONTH_YEAR_DATE_FORMAT}
                    maxDate={moment()}
                    label="Date"
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={6}>
                  <Field
                    label={'Non Needy Item'}
                    name={Fields.NonNeedyItemId}
                    component={SelectField}
                    options={nonNeedyItemOptions}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column className="field">
                  <label className={'p-b-0'}>Sites</label>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Field name={Fields.SiteIds} component={SelectSitesTable} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  let errors = {};

  if (!values[Fields.MealType]) {
    errors[Fields.MealType] = 'Meal Type must be selected.';
  }

  if (!values[Fields.SiteIds].length) {
    errors[Fields.SiteIds] = 'At least one site must be selected.';
  }

  if (!moment(values[Fields.Date], MONTH_YEAR_DATE_FORMAT).isValid()) {
    errors[Fields.Date] = 'A valid date must be selected.';
  }

  return errors;
};

export default reduxForm({
  form: OHIO_DAILY_WORKSHEET_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
})(withRouter(OhioDailyWorksheetFormContainer));



// WEBPACK FOOTER //
// ./src/pages/ohiodailyworksheetreport/components/OhioDailyWorksheetForm.js